export class ChronosActivityResultActions{
    ActivityID: number = null;
    PriorityID: number = null;
    PostActivityID: number = null;
   // PostActivity: any;
}



// WEBPACK FOOTER //
// ./app/insa-models/chronos-post-action.model.ts